import { getRedisClient } from "../../client";
import { getKey } from "../../utils/redisKeys";

const prefix = "render:path";

export async function setRender(app: string, path: string, value: any, ttlInSec?: number): Promise<void> {
    const client = getRedisClient();
    const key = getKey({ prefix, namespace: app, id: path });
    const stringified = JSON.stringify(value);

    if (ttlInSec) {
        await client.set(key, stringified, { EX: ttlInSec });
    } else {
        await client.set(key, stringified);
    }
}

export async function getRender<T = any>(app: string, path: string): Promise<T | null> {
    const client = getRedisClient();
    const key = getKey({ prefix, namespace: app, id: path });
    const data = await client.get(key);
    return data ? JSON.parse(data) : null;
}

export async function deleteRender(app: string, path: string): Promise<void> {
    const client = getRedisClient();
    const key = getKey({ prefix, namespace: app, id: path });
    await client.del(key);
}

export async function deleteAllRender(app: string): Promise<void> {
    const client = getRedisClient();
    const pattern = getKey({ prefix, namespace: app, id: "*" });
    const keys = await client.keys(pattern);
    if (keys.length) {
        await client.del(keys);
    }
}